biit-artist {
    display: block;
}

/* Main container */
.biit-artist {
    background-color: var(--background-color, #fff);
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    padding: 20px;
    max-width: 800px;
    margin: 20px auto;
    position: relative;
    color: var(--text-color, #333);
    font-family: var(--font-family, 'Arial', sans-serif);

    .biit-logo {
        svg {
            width: 32px;
            position: absolute;
            top: 0.5rem;
            right: 0.5rem;
        }

        &:hover {
            opacity: 0.8;
        }
    }
}

/* Header Section */
.biit-artist__header {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

.biit-artist__image {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    object-fit: cover;
    margin-right: 20px;
}

.biit-artist__info {
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.biit-artist__name {
    font-size: 24px;
    margin: 0;
    font-weight: 600;
}

.biit-artist__tracker {
    font-size: 14px;
    color: var(--text-color);
    margin-top: 5px;
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
    align-items: center;
}

/* Social & Music Links */
.biit-artist__links {
    display: flex;
    margin-top: 10px;
}

.biit-artist__link {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    margin-right: 10px;
    border-radius: 50%;
    background-color: rgba(256, 256, 256, 0.1);
    color: var(--text-color);
    text-decoration: none;
    transition: background-color 0.3s ease, color 0.3s ease;
}

.biit-artist__link:hover {
    background-color: #ddd;
    color: #333;
}

/* Events Section */
.biit-artist__events {
    border-top: 1px solid #eee;
    padding-top: 20px;
}

.biit-artist__events h3 {
    font-size: 20px;
    margin: 0 0 10px;
    font-weight: 500;
}

.biit-artist__no-events {
    font-style: italic;
    color: #999;
    font-size: 14px;
}

/* Individual Event Item */
.biit-artist__event {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 0;
    border-bottom: 1px solid #eee;
}

.biit-artist__event:last-child {
    border-bottom: none;
}

.biit-artist__event-info {
    display: flex;
    flex-direction: column;
    flex: auto;
    color: var(--text-color);
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
}

.biit-artist__event-name {
    font-size: 18px;
    margin: 0;
    font-weight: 500;
    text-decoration: none;
}

.biit-artist__event-date,
.biit-artist__event-location,
.biit-artist__event-lineup {
    font-size: 14px;
    color: var(--text-color);
    margin: 2px 0;
    text-decoration: none;
}

/* Ticket Button */
.biit-artist__event-tickets {
    background-color: var(--button-bg-color, #af1313);
    color: #fff;
    padding: 8px 12px;
    border-radius: 4px;
    text-decoration: none;
    font-size: 14px;
    transition: background-color 0.3s ease;
}

.biit-artist__event-tickets:hover {
    background-color: var(--button-bg-color-hover, #5c0606);
}